import React from 'react';
import { PropTypes } from 'prop-types';

const Note = ({
  siteName, date, title, content = '', status = 'Open', priority = 'No priority', onClick,
}) => {
  const borderColor = () => {
    if (priority === 'low') return 'bg-priority-low';
    if (priority === 'medium') return 'bg-priority-medium';
    if (priority === 'high') return 'bg-priority-high';
    return 'bg-vamos-gray';
  };

  return (
    <button type="button" onClick={onClick} className="max-w-87 bg-vamos-white h-auto rounded-10px overflow-hidden shadow-vamos-shadow border-2 hover:no-underline hover:border-vamos-black text-left font-sans">
      <div className={`${borderColor()} h-2`} />
      <div className="px-6 py-3">
        <div className="h-14 overflow-hidden">
          <h2 className="font-bold text-lg mb-0 line-clamp-2">{siteName}</h2>
        </div>
        <div className="flex items-center mt-1">
          <span className="font-bold pr-1 text-sm">STATUS:</span>
          <h3 className="text-sm font-normal mb-0">{status}</h3>
        </div>
      </div>
      <div className="border-t-2 px-6 py-3 h-2/3">
        <div className="flex justify-between items-center mb-2">
          <h2 className="font-bold text-lg">{title}</h2>
          <h3 className="text-sm font-normal">{date}</h3>
        </div>
        <p className="line-clamp-5 mb-0 text-lg">{content}</p>
      </div>
    </button>
  );
};

Note.propTypes = {
  siteName: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  status: PropTypes.string,
  priority: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default Note;
